<template>
  <div>
    <IO
      class="io"
      v-for="IOData in IOListData"
      :IOData="IOData"
      :key="IOData.key"
      :agencyId="agencyId"
      :selectedPointGroup="selectedPointGroup"
    />
  </div>
</template>

<script>
import IO from '@/components/Advertiser/Operation/PointGroup/PointGroupCatalog/IO/IO'
export default {
  name: 'IOList',
  components: {
    IO,
  },
  props: {
    IOListData: Array,
    agencyId: Number,
    selectedPointGroup: Array,
  },
}
</script>

<style scoped>
.io {
  margin-bottom: 8px;
}
</style>
